import Udesk from 'Udesk';

export const getCheckPointType = (item) => {
    // 智能体也使用intelligentCustomModelId，，故先判断是否为智能体
    return item.type === Udesk.enums.scoreType.aiAgent.id
        ? Udesk.enums.scoreType.getName(item.type)
        : // 此处当存在 secondType 或者 intelligentCustomModelId，认为是智能模型类型
        item.secondType || item.intelligentCustomModelId
        ? Udesk.enums.scoreType.intelligentModel.name
        : Udesk.enums.scoreType.getName(item.type);
};
